import './star-rating.scss';

StarRating.DIRECTIVE_NAME = 'ktStarRating';
export default function StarRating() {
    return {
        restrict: 'A',
        link,
    };

    function link($scope, $elem, $attrs) {
        const value = $scope.$eval($attrs.ktStarRating);
        const classSuffix = Number.isInteger(value) ? value : 'hidden';
        $elem.addClass(`glyphicon star-rating-${classSuffix}`);
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/common/widgets/star-rating/star-rating-directive.js